import { render, staticRenderFns } from "./Commerce.vue?vue&type=template&id=6596099f&"
import script from "./Commerce.vue?vue&type=script&lang=js&"
export * from "./Commerce.vue?vue&type=script&lang=js&"
import style0 from "./Commerce.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Commerce.vue"
export default component.exports